import React, { useState } from 'react';
import { Button, message } from 'antd';
import axios from 'axios';
import I18n from 'i18n-js';
import { func, number } from 'prop-types';
import { create_jira_issue_ticket_path } from 'js-routes/generated/routes';
import JiraIcon from './JiraIcon';

const JiraCreateButton = ({ ticketId, onCreated }) => {
  const [isCreating, setIsCreating] = useState(false);

  const handleClick = async () => {
    setIsCreating(true);

    try {
      const response = await axios({
        headers: { Accept: 'application/json' },
        responseType: 'json',
        method: 'post',
        url: create_jira_issue_ticket_path(ticketId),
      });

      onCreated(response.data.jiraLink);
      message.success(I18n.t('flash.tickets.jira_issue_created'));
    } catch (error) {
      message.error(
        error.response?.data?.jira_link?.[0] ?? I18n.t('flash.tickets.jira_issue_failed'),
      );
    } finally {
      setIsCreating(false);
    }
  };

  return (
    <Button
      icon={<JiraIcon />}
      loading={isCreating}
      onClick={handleClick}
    >
      {I18n.t('tickets.form.jira_create')}
    </Button>
  );
};

JiraCreateButton.propTypes = {
  ticketId: number.isRequired,
  onCreated: func.isRequired,
};

export default JiraCreateButton;
